import type { ExternalBaseLinkId } from 'cadenza/repository/model/external-base-link-id';
import { ajax } from 'cadenza/api-client/api';
import type { RepositoryItemDto } from 'cadenza/repository/model/repository-item-dto';

export async function getTargetOrigin (baseLinkId: ExternalBaseLinkId) {
  const baseLink = await getExternalLink(baseLinkId);
  if (baseLink.allowPostMessage) {
    return new URL(baseLink.urlPart).origin;
  }
}
export interface ExternalBaseLinkDto extends RepositoryItemDto<'EXTERNAL_BASE_LINK'> {
  urlPart: string;
  templateId?: string;
  allowPostMessage: boolean;
}

export function getExternalLink ({ repositoryName, itemName }: ExternalBaseLinkId, signal?: AbortSignal) {
  return ajax<ExternalBaseLinkDto>(`/repositories/${repositoryName}/externallinks/${itemName}`, { signal });
}
